<mat-toolbar color="primary" class="mat-elevation-z2">
  <div style="display: flex; align-items: center;">
    <img id="SidebarLogo" src="assets/Logo - login.png" class="sidebarlogo">
  </div>
  <div id="HeaderMid" style="flex: 1; display: flex; justify-content: center;">
    <h1 style="margin-right: 200px;">{{pagename}}</h1>
  </div>
  <mat-slide-toggle [checked]="darkMode" matTooltip="Dark Mode" (change)="toggleDarkTheme($event.checked)">
    <mat-icon style="display: flex;">dark_mode</mat-icon>
  </mat-slide-toggle>
  <div class="d-flex align-items-center">
    @if (!router.isActive('/Contact-Search', true)) {
    <app-search></app-search>
    }
  </div>
  <div style="display: flex; align-items: center; gap: 1rem;">
    <app-notification-history></app-notification-history>
    @if (isImpersonating) {
    <button mat-mini-fab matTooltip="End Impersonation" (click)="endImpersonation()" color="warn">
      <mat-icon>person_off</mat-icon>
    </button>
    }
    @if (userService.hasRole([roles.Admin]) && !isImpersonating) {
    <button mat-mini-fab matTooltip="Impersonate Roles" (click)="openImpersonationDialog()">
      <mat-icon>manage_accounts</mat-icon>
    </button>
    }
  </div>
</mat-toolbar>

<mat-sidenav-container>
  <mat-sidenav #sidenav mode="side" opened="true" class="slim-sidenav">
    <div class="sidenav-content">
      <div class="top-icons">
        @if (contactService.currentContactId() && isNumber(contactService.currentContactId())) {
        <button matMiniFab matTooltip="Contact" matTooltipPosition="right" aria-label="Contact"
          [routerLink]="['/Contact', contactService.currentContactId()]">
          <mat-icon>person</mat-icon>
        </button>
        } @else {
        <button matMiniFab matTooltip="Contact Search" matTooltipPosition="right" aria-label="Contact Search"
          [routerLink]="['/Contact-Search']">
          <mat-icon>person_search</mat-icon>
        </button>
        }
        <button matMiniFab matTooltip="Recent" matTooltipPosition="right" aria-label="Recent"
          [routerLink]="['/Recent']">
          <mat-icon>history</mat-icon>
        </button>
        <button matMiniFab matTooltip="Part Search" matTooltipPosition="right" aria-label="Recent"
          [routerLink]="['/Part-Search']">
          <mat-icon>search</mat-icon>
        </button>
        <button matMiniFab matTooltip="What's New" matTooltipPosition="right" aria-label="What's New"
          [routerLink]="['/Whats-New']">
          <mat-icon matBadge="!" matBadgeColor="warn" matBadgeSize="small"
            [matBadgeHidden]="(patchNotesService.hasUnseen$ | async) !== true">campaign</mat-icon>
        </button>
        @if ((userService.hasRole([roles.Admin]))){
        <button matMiniFab matTooltip="Admin" matTooltipPosition="right" aria-label="Admin" [routerLink]="['/Admin']">
          <mat-icon>admin_panel_settings</mat-icon>
        </button>
        }
      </div>
      <div class="bottom-icon">
        <button matMiniFab matTooltip="Logout" matTooltipPosition="right" aria-label="Logout" (click)="logout()">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
      <div style="text-align: center;">
        {{ appVersion }}
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-spinner></app-spinner>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
